module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "icon": "upload"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSpDiv"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.fType),
      callback: function($$v) {
        _vm.fType = $$v
      },
      expression: "fType"
    }
  }, _vm._l((_vm.$firmwareTypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "icon": "search",
      "on-icon-click": _vm.search,
      "placeholder": _vm.$t('app_name')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.qName),
      callback: function($$v) {
        _vm.qName = $$v
      },
      expression: "qName"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "firmwareName",
      "label": _vm.$t('lin_global.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyPass')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyNotPass')))]) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "popover",
            rawName: "v-popover:popover2",
            arg: "popover2"
          }, {
            name: "show",
            rawName: "v-show",
            value: (scope.row.status === 3),
            expression: "scope.row.status === 3"
          }],
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('i', {
          staticClass: "el-icon-information",
          staticStyle: {
            "color": "#58B7FF"
          }
        }), _vm._v(" "), _c('el-popover', {
          ref: "popover2",
          attrs: {
            "placement": "top",
            "title": "",
            "width": "",
            "trigger": "click",
            "content": scope.row.auditContent
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "downloads",
      "label": _vm.$t('lin_global.downNumber'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "header-align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status === 0 || scope.row.status === 3),
            expression: "scope.row.status === 0 || scope.row.status === 3"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editFw(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status === 0 || scope.row.status === 3),
            expression: "scope.row.status === 0 || scope.row.status === 3"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitFw(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delFw(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.pageSized,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c35e7050"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/firmware/manage.vue
// module id = 1121
// module chunks = 0